import { getEventTypeGroupFromJson } from '../../events/data_types'
import dataTypes from './data_types_config.json'

export const rugbyUnionEventTypes = getEventTypeGroupFromJson(
  dataTypes,
  'Rugby Union'
)

console.log(rugbyUnionEventTypes)
